// FIXME Deprecated
// All colors should come from styles/www/colors.scss
// However, the colors below are from an earlier era,
// and must be preserved until analytics apps have been
// redesigned to use the new color scheme.

import {getSecondary} from 'common/utils/color-util';

const black = '#000000';
const blue = '#06a8de';
const blueGray = '#4c76a8';
const darkGray = '#666666';
const gray = '#999999';
const green = '#87c352';
const lavender = '#a28fc1';
const lightBlue = '#aad3e1';
const lightGray = '#f6f6f6';
const lime = '#97df89';
const midGray = '#666666';
const orange = '#f59743';
const papaya = '#f1765d';
const pink = '#ff00cc';
const purple = '#825475';
const red = '#e34743';
const yellow = '#ffff00';
const white = '#ffffff';

export const BLACK = {
  primary: black,
  secondary: black,
  slug: 'black',
};
export const BLUE = {
  primary: blue,
  secondary: getSecondary(blue),
  slug: 'blue',
};
export const BLUE_GRAY = {
  primary: blueGray,
  secondary: getSecondary(blueGray),
  slug: 'blueGray',
};
export const DARK_GRAY = {
  primary: darkGray,
  secondary: getSecondary(darkGray),
  slug: 'darkGray',
};
export const GRAY = {
  primary: gray,
  secondary: getSecondary(gray),
  slug: 'gray',
};
export const GREEN = {
  primary: green,
  secondary: getSecondary(green),
  slug: 'green',
};
export const LAVENDER = {
  primary: lavender,
  secondary: getSecondary(lavender),
  slug: 'lavender',
};
export const LIGHT_BLUE = {
  primary: lightBlue,
  secondary: getSecondary(lightBlue),
  slug: 'lightBlue',
};
export const LIGHT_GRAY = {
  primary: lightGray,
  secondary: getSecondary(lightGray),
  slug: 'lightGray',
};
export const LIME = {
  primary: lime,
  secondary: getSecondary(lime),
  slug: 'lime',
};
export const MID_GRAY = {
  primary: midGray,
  secondary: getSecondary(midGray),
  slug: 'midGray',
};
export const ORANGE = {
  primary: orange,
  secondary: getSecondary(orange),
  slug: 'orange',
};
export const PAPAYA = {
  primary: papaya,
  secondary: getSecondary(papaya),
  slug: 'papaya',
};
export const PINK = {
  primary: pink,
  secondary: getSecondary(pink),
  slug: 'pink',
};
export const PURPLE = {
  primary: purple,
  secondary: getSecondary(purple),
  slug: 'purple',
};
export const RED = {
  primary: red,
  secondary: getSecondary(red),
  slug: 'red',
};
export const YELLOW = {
  primary: yellow,
  secondary: getSecondary(yellow),
  slug: 'yellow',
};
export const WHITE = {
  primary: white,
  secondary: white,
  slug: 'white',
};
